import { EnterpriseObjectApi } from 'api-typings/users/users';
import { EnterpriseModel } from './enterprises.model';

export function transformEnterprise(
  enterprise: EnterpriseObjectApi,
): EnterpriseModel {
  if (enterprise.is_test_enterprise === undefined) {
    throw new ReferenceError(
      'Enterpise does not have `is_test_enterprise` attribute',
    );
  }

  return {
    id: enterprise.id,
    internal_name: enterprise.internal_name,
    name: enterprise.name,
    is_test_enterprise: enterprise.is_test_enterprise,
    seo_url: enterprise.seo_url,
  };
}
